import { useEffect, useState } from 'react'

/** seconds left before an action, like resending a code, is allowed again. */
export function useCooldown(seconds: number) {
  const [remaining, setRemaining] = useState(0)

  useEffect(() => {
    if (remaining <= 0) return
    const id = setTimeout(() => setRemaining(left => left - 1), 1000)
    return () => clearTimeout(id)
  }, [remaining])

  return {
    remaining,
    start: () => setRemaining(seconds),
    clear: () => setRemaining(0)
  }
}
